<form [formGroup]="dossierItemFg">
  <snelstart-ui-text-form-control (change)="saveForm()"
                                  [disabledControl]="dossierItemFg.get('creator')?.value === 'SnelStart'"
                                  class="custom-input-400"
                                  formControlName="clientName"
                                  id="name"
                                  label="Klant"
  >
  </snelstart-ui-text-form-control>
  <snelstart-ui-textarea-form-control (change)="saveForm()"
                                      [disabledControl]="dossierItemFg.get('creator')?.value === 'SnelStart'"
                                      [rows]="10"
                                      class="custom-input-400"
                                      formControlName="opmerkingen"
                                      id="opmerkingen"
                                      label="Notitie"
  >
  </snelstart-ui-textarea-form-control>
    <snelstart-ui-textarea-form-control [disabledControl]="true"
                                        [rows]="12"
                                        class="custom-input-400"
                                        formControlName="handelingsperspectief"
                                        id="handelingsperspectief"
                                        label="Actie">
    </snelstart-ui-textarea-form-control>
    <div class="mb-2">
        <snelstart-ui-button (click)="kopieerEmailTekst()"
                             icon="envelope"
                             type="secondary">
            Kopieer gegevens voor e-mail
        </snelstart-ui-button>
    </div>
</form>

